import ServicesHeroSection from "../companents/Services/ServicesHeroSection/Index";
import ServicesSecondSection from "../companents/Services/ServicesSecondSection/Index";
import { Helmet } from "react-helmet";
import HomeServices from '../companents/Home/HomeServices/Index'
const Services = () => {



  return (
    <>
      <Helmet>
        <title>Xidmətlərimiz</title>
      </Helmet>

      <div>

        <HomeServices />
        {/* <ServicesSecondSection /> */}
      </div>

    </>
  );
};

export default Services;
